<template>
    <div class="pat-page">
        <h1 class="pat-main-title">
            Mes actualités locales en partenariat avec {{ patData?.name }}
        </h1>

        <!-- On affiche uniquement si au moins une actualité existe -->
        <div v-if="!loading && patData && hasAnyNews" class="pat-section">
            <!-- SECTION CLS/PAT (blocs 1-3) -->
            <div v-if="hasPatNews" class="pat-subsection">

                <!-- BLOC 1 -->
                <div v-if="hasBlock1" class="pat-row" id="actualite-pat-1">
                    <div v-if="patData.image_1" class="pat-img-wrapper">
                        <img class="pat-img" :src="fullImage(patData.image_1)" />
                    </div>

                    <div :class="['pat-content', { 'full-width': !patData.image_1 }]">
                        <h3>{{ patData.title_1 }}</h3>
                        <p v-html="patData.text_1"></p>

                        <a v-if="patData.link_1" :href="patData.link_1" target="_blank" class="pat-link">
                            En savoir plus →
                        </a>
                    </div>
                </div>

                <!-- BLOC 2 -->
                <div v-if="hasBlock2" class="pat-row" id="actualite-pat-2">
                    <div v-if="patData.image_2" class="pat-img-wrapper">
                        <img class="pat-img" :src="fullImage(patData.image_2)" />
                    </div>

                    <div :class="['pat-content', { 'full-width': !patData.image_2 }]">
                        <h3>{{ patData.title_2 }}</h3>
                        <p v-html="patData.text_2"></p>

                        <a v-if="patData.link_2" :href="patData.link_2" target="_blank" class="pat-link">
                            En savoir plus →
                        </a>
                    </div>
                </div>

                <!-- BLOC 3 -->
                <div v-if="hasBlock3" class="pat-row" id="actualite-pat-3">
                    <div v-if="patData.image_3" class="pat-img-wrapper">
                        <img class="pat-img" :src="fullImage(patData.image_3)" />
                    </div>

                    <div :class="['pat-content', { 'full-width': !patData.image_3 }]">
                        <h3>{{ patData.title_3 }}</h3>
                        <p v-html="patData.text_3"></p>

                        <a v-if="patData.link_3" :href="patData.link_3" target="_blank" class="pat-link">
                            En savoir plus →
                        </a>
                    </div>
                </div>
            </div>

            <!-- SECTION MMMENUS (bloc 4) -->
            <div v-if="hasMMMNews" class="pat-subsection">

                <div v-if="hasBlock4" class="pat-row" id="actualite-mmmenus-4">
                    <div v-if="patData.image_4" class="pat-img-wrapper">
                        <img class="pat-img" :src="fullImage(patData.image_4)" />
                    </div>

                    <div :class="['pat-content', { 'full-width': !patData.image_4 }]">
                        <h3>{{ patData.title_4 }}</h3>
                        <p v-html="patData.text_4"></p>

                        <a v-if="patData.link_4" :href="patData.link_4" target="_blank" class="pat-link">
                            En savoir plus →
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <!-- Si pas d'actualités : on n'affiche rien (aucun bloc) -->
    </div>
</template>

<script>
import { api } from "@/api";

export default {
    name: "ActualitesPat",

    data() {
        return {
            patData: null,
            loading: true,
        };
    },

    computed: {
        hasBlock1() {
            return !!(this.patData && (this.patData.title_1 || this.patData.text_1));
        },
        hasBlock2() {
            return !!(this.patData && (this.patData.title_2 || this.patData.text_2));
        },
        hasBlock3() {
            return !!(this.patData && (this.patData.title_3 || this.patData.text_3));
        },
        hasBlock4() {
            return !!(this.patData && (this.patData.title_4 || this.patData.text_4));
        },

        hasPatNews() {
            return this.hasBlock1 || this.hasBlock2 || this.hasBlock3;
        },
        hasMMMNews() {
            return this.hasBlock4;
        },
        hasAnyNews() {
            return this.hasPatNews || this.hasMMMNews;
        },
    },

    methods: {
        async loadPat() {
            try {
                const response = await api.get("/my-pat/");
                this.patData = response.data.pat;
            } catch (error) {
                console.error("Erreur lors du chargement PAT :", error);
            } finally {
                this.loading = false;
            }
        },

        fullImage(url) {
            if (!url) return null;

            const base = (process.env.VUE_APP_BASE_URL || "").replace(/\/+$/, "");
            const path = String(url).replace(/^\/+/, "");

            return `${base}/${path}`;
        },
    },

    created() {
        this.loadPat();
    },
};
</script>

<style scoped>
.pat-page {
    padding: 25px;
    max-width: 70%;
    margin: auto;
}

.pat-main-title {
    font-size: 28px;
    margin-bottom: 30px;
    font-weight: bold;
}

.pat-section {
    display: flex;
    flex-direction: column;
    gap: 50px;
}

.pat-subsection {
    display: flex;
    flex-direction: column;
    gap: 40px;
}

.pat-section-title {
    font-size: 22px;
    font-weight: 700;
    margin: 0;
}

.pat-row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 25px;
}

.pat-img-wrapper {
    flex: 0 0 calc(30% - (25px / 2));
    max-width: calc(30% - (25px / 2));
}

img.pat-img {
    max-width: 100%;
}

.pat-content {
    flex: 0 0 calc(70% - (25px / 2));
    max-width: calc(70% - (25px / 2));
}

.pat-content.full-width {
    flex: 0 0 100%;
    max-width: 100%;
}

.pat-link {
    display: inline-block;
    margin-top: 10px;
    font-weight: bold;
    color: #007bff;
}
</style>
